var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLogin || !_vm.needJudgeLogin)?_c('YKDHeader',{attrs:{"needRouter":true,"menuM":_vm.menuListMed,"menu":_vm.menuList},on:{"onSearch":_vm.onSearch}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }